import { render } from "./TransactionsView.vue?vue&type=template&id=3fe6dd6c"
import script from "./TransactionsView.vue?vue&type=script&lang=js"
export * from "./TransactionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__